import { t } from 'Src/i18n';
export const getLabel = ({
  isJoyview,
  isTour,
}: {
  isJoyview: boolean;
  isTour: boolean;
}): string => {
  if (isTour) {
    return '';
  }

  return isJoyview ? t('resort.startingPrice.roomOnly') : t('resort.startingPrice.allInclusive');
};
